import { render, staticRenderFns } from "./PedidoItems.vue?vue&type=template&id=b61b67cc&scoped=true&"
import script from "./PedidoItems.vue?vue&type=script&lang=js&"
export * from "./PedidoItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61b67cc",
  null
  
)

export default component.exports